<div class="PGUser {{ vertical ? 'PGUser--Vertical' : ''}} {{ small ? 'PGUser--Small' : '' }}">
    @if (user) {
        <div class="mb-2">
            <h5 class="m-0">{{user.id}} - {{user.name}} {{user.surname}}</h5>
            @if (user.codice_fiscale) {
                <div class="font-monospace mt-1">{{ user.codice_fiscale }}</div>
            }
        </div>
        <div class="PGUser-Contacts {{ profile ? 'mb-1' : '' }}">
            @if (user.email) {
                <div>
                    <a href="mailto:{{user.email}}" target="_blank">{{user.email}}</a>
                </div>
            }
            @if (user.email && user.telephone) {
                <div class="ms-2 PGUser-Contacts-Split"></div>
            }
            @if (user.telephone) {
                <div>
                    <a href="tel:{{user.telephone}}" target="_blank">{{user.telephone}}</a>
                </div>
            }
        </div>
    }
    @if (profile) {
        @if (profile.company || profile.vat_number) {
            <div class="PGUser-Company">
                @if (profile.company) {
                    <div>{{profile.company}}</div>
                }
                @if (profile.company && profile.vat_number) {
                    <div class="mx-1 PGUser-Company-Split">-</div>
                }
                @if (profile.vat_number) {
                    <div class="small text-muted">{{profile.vat_number}}</div>
                }
            </div>
        }
    }
</div>